<!--Header Section start-->
<app-header></app-header>
<app-modal></app-modal>
<!--Header Section end-->

<section id="pdog-ui">
    <div class="container">
        <div>
            <div class="row justify-content-center">
                <div class="col-custom col-lg-4 col-md-6 px-lg-0 px-0">
                    <!-- Button trigger modal
                    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        Open modal
                    </button> -->
                    <ul class="nav nav-pills nav-fill justify-content-center mt-3" id="pills-tab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="pills-migrate-tab" data-bs-toggle="pill" data-bs-target="#pills-migrate" type="button" role="tab" aria-controls="pills-migrate" aria-selected="true">Migrate</button>
                        </li>
                        <!-- <li class="nav-item" role="presentation">
                            <button class="nav-link" id="pills-bridge-tab" data-bs-toggle="pill" data-bs-target="#pills-bridge" type="button" role="tab" aria-controls="pills-bridge" aria-selected="false">Bridge</button>
                        </li> -->
                        <!-- <li class="nav-item" role="presentation">
                            <button class="nav-link" id="pills-pool-tab" data-bs-toggle="pill" data-bs-target="#pills-pool" type="button" role="tab" aria-controls="pills-pool" aria-selected="false">Liquidity Pool</button>
                        </li> -->
                    </ul>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-custom col-lg-5 col-md-6 px-lg-0 px-0">
                    <div class="tab-content" id="pills-tabContent">
                        <div class="tab-pane fade show active" id="pills-migrate" role="tabpanel" aria-labelledby="pills-migrate-tab">
                            <app-migration></app-migration>
                        </div>
                        <div class="tab-pane fade" id="pills-bridge" role="tabpanel" aria-labelledby="pills-bridge-tab">
                           
                        </div>
                        <div class="tab-pane fade" id="pills-pool" role="tabpanel" aria-labelledby="pills-pool-tab">
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
